import { AutoPopupModal } from '@/components/widgets/modal';
import styles from './golden-duel-promo-modal.module.scss';
import { antonio } from '@/lib/fonts';
import clsx from 'clsx';
import { Icon } from '@/components/icons/svg-icons';
import { useState } from 'react';
import { Button } from '@nf/ui';
import { switchViewService } from '@/services/swtich-view.service';
import { useAccountInfo } from '@/hooks/query/account';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { SiteConfigsSettingsData } from '@nf/types/site';
import { goldenDuelModalService } from '@/services/golden-duel/golden-duel-modal.service';
import { useTranslations } from 'next-intl';
import { useLocalStorage } from '@nf/utils-common/hooks';
import { useGoldenDuelNavigation } from '@/hooks/golden-duel';
import webStorageKeys from '@/constants/web-storage-keys';
import { KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { useLocale } from 'next-intl';
import { CdnImg } from '@/features/cdn-img';
import { AutoPopupKey } from '@nf/auto-popup-handler';

export const GoldenDuelPromoModal = () => {
	const t = useTranslations('General');
	const [isOpen, setIsOpen] = useState(true);
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const shortCode = switchViewService.convertLanguageToShortCode(user?.Lang as string, SiteConfigsData as SiteConfigsSettingsData);
	const { navigateToFirstUndrawnMatch, hasAvailableMatch } = useGoldenDuelNavigation();
	const [, setIsGoldenDuelPromoTriggered] = useLocalStorage(webStorageKeys.GOLDEN_DUEL_PROMO_TRIGGERED, false);
	const locale = useLocale();
	const isUseNewFont = !['th-TH', 'vi-VN'].includes(locale);

	const closeModal = (isCloseBtn = false) => {
		setIsGoldenDuelPromoTriggered(true);
		setIsOpen(false);
		if (isCloseBtn) {
			setKafka(3);
		}
	}

	const handleLearnMore = () => {
		closeModal(false);
		setKafka(1);
		goldenDuelModalService.displayGoldenDuelRulesModal(true);
	}

	const handlePlayNow = async () => {
		await navigateToFirstUndrawnMatch();
		closeModal(false);
		setKafka(2);
	}

	const setKafka = (action: number) => {
		const kafkaData = {
			note: KafkaNote.GoldenDuel,
			type: 1,
			action
		}
		setKafkaNormal(kafkaData);
	}

	return (
		<AutoPopupModal
			popupKey={AutoPopupKey.GoldenDuelPromo}
			isOpen={isOpen}
			variant="event"
			closeModal={() => closeModal(true)}
			showHeader={false}
			className={styles.promoModal}
			isShowClose={true}
			isBackdropClose={false}
		>
			<div className={styles.modalContent}>
				<Button variant="icon" className={styles.closeButton} onClick={() => closeModal(true)}>
					<Icon name="close-round-line" />
				</Button>
				<div className={styles.backgroundWrapper}>
					<CdnImg
						isGalaxyFolder={true}
						className={styles.backgroundImage}
						src="/images/promotion/golden-duel/event-modal/animation-bg.png"
						alt="Background"
						width={396}
						height={329}
					/>
				</div>
				<div className={styles.title}>
					<CdnImg
						isGalaxyFolder={true}
						src={`/images/promotion/golden-duel/event-modal/event-title/${shortCode}/event-title.png`}
						alt="Title"
					/>
				</div>
				<div className={styles.animationArea}>
					<CdnImg
						isGalaxyFolder={true}
						src="/images/promotion/golden-duel/event-modal/light-bg.png"
						className={clsx(styles.animationImage, styles.lightBg)}
						alt="Ticket Background"
						width={250}
						height={250}
					/>
					<CdnImg
						isGalaxyFolder={true}
						src="/images/promotion/golden-duel/event-modal/ticket.png"
						className={clsx(styles.animationImage, styles.ticket)}
						alt="Ticket" 
						width={143}
						height={122}
					/>
					<CdnImg
						isGalaxyFolder={true}
						src="/images/promotion/golden-duel/event-modal/ticket-small.png"
						className={clsx(styles.animationImage, styles.ticketSmall)}
						alt="Ticket Small"
						width={213}
						height={140}
					/>
					<CdnImg
						isGalaxyFolder={true}
						src="/images/promotion/golden-duel/event-modal/coin-1.png"
						className={clsx(styles.animationImage, styles.coin1)}
						alt="Coin 1"
						width={129}
						height={134}
					/>
					<CdnImg
						isGalaxyFolder={true}
						src="/images/promotion/golden-duel/event-modal/coin-2.png"
						className={clsx(styles.animationImage, styles.coin2)}
						alt="Coin 2"
						width={125}
						height={104}
					/>
				</div>

				<div className={styles.contentWrapper}>
					<div className={styles.titleGroup}>
						<div className={clsx(styles.mainTitle, isUseNewFont ? antonio.className : 'specialFont')}>{t('lbl_EventPopupSubtitle')}</div>
						<div className={clsx(styles.subTitle, isUseNewFont ? antonio.className : 'specialFont')}>{t('lbl_EventPopupSubtitle2')}</div>
					</div>

					<div className={styles.decorationImage}>
						<CdnImg
							isGalaxyFolder={true}
							src="/images/promotion/golden-duel/event-modal/star.svg"
							alt="Star"
						/>
					</div>

					<div className={styles.description}>
						{t('lbl_EventPopupDesc')}
					</div>

					<div className={styles.buttonGroup}>
						<button
							className={clsx(styles.button, styles.learnMoreButton)}
							onClick={handleLearnMore}
						>
							{t('lbl_LearnMore')}
						</button>
						{hasAvailableMatch &&
							<button
								className={clsx(styles.button, styles.playNowButton)}
								onClick={handlePlayNow}
							>
								{t('lbl_PlayNow')}
							</button>}
					</div>
				</div>
			</div>
		</AutoPopupModal>
	);
}